export const postStatus = Object.freeze({
  PUBLISHED: 'published',
  UNPUBLISHED: 'unpublished',
  DRAFT: 'draft',
  SCHEDULED: 'scheduled'
});

export const postType = Object.freeze({
  NEWS: 'news',
  CASE_STUDY: 'case_study',
  SKILL_SUPPORT: 'skill_support',
  JOB_HUNTING: 'job_hunting'
});

export const postTypeName = Object.freeze({
  NEWS: '新着情報',
  CASE_STUDY: '就職活動事例（体験談）',
  SKILL_SUPPORT: 'スキル習得支援メニュー',
  JOB_HUNTING: '就職活動支援メニュー'
});

export const getDate = (defautTime) => {
  const currDate = new Date();
  const currTime = currDate.getHours();
  return currTime < defautTime ? currDate : currDate.setDate(currDate.getDate() + 1);
};

// export const times = [
//   '00:00',
//   '01:00',
//   '02:00',
//   '03:00',
//   '04:00',
//   '05:00',
//   '06:00',
//   '07:00',
//   '08:00',
//   '09:00',
//   '10:00',
//   '11:00',
//   '12:00',
//   '13:00',
//   '14:00',
//   '15:00',
//   '16:00',
//   '17:00',
//   '18:00',
//   '19:00',
//   '20:00',
//   '21:00',
//   '22:00',
//   '23:00',
//   '23:00'
// ];

// Get schedule custom times
export const getTimes = () => {
  let times = [];

  for (let i = 0; i <= 23; i++) {
    const number = `${String(i).padStart(2, "0")}:00`;
    times.push(number);
  }

  return times;
};

export const pageSizes = ['10', '30', '50', '100'];

// Get minutes
export const getMinutes = () => {
  let minutes = [];
  let minus = 0;
  while ( minus <= 55) {
    const number = `${String(minus).padStart(2, "0")}`;
    minutes.push(number);
    minus += 5;
  }
  return minutes;
};

// Get hours
export const getHours= () => {
  let hours = [];
  let hour = 0;
  while ( hour <= 23) {
    const number = `${String(hour).padStart(2, "0")}`;
    hours.push(number);
    hour++;
  }
  return hours;
};